export default __webpack_public_path__ + "static/media/levels_and_skills_preview.b2419219.png";